import { m as mapFormFields } from "../../../../../chunks/mapFormFields.js";
import { s as server2server } from "../../../../../chunks/server2server.js";
import { f as fail } from "../../../../../chunks/index.js";
const actions = {
  saveClientAddress: async ({ request, locals, fetch, params }) => {
    const fields = ["street", "number", "place", "zip", "country", "uuid", "customerUuid"];
    let payload = await mapFormFields(request, fields);
    const api = server2server({ locals });
    let response;
    try {
      if (payload.uuid) {
        response = await api.put(`/address/${payload.uuid}`, payload);
      } else {
        response = await api.post("/address", payload);
      }
    } catch (e) {
      console.error(e);
      return fail(400, {
        message: "Failed to update base data",
        message_status: e.message
      });
    }
    console.log(response);
    return response;
  }
};
export {
  actions
};
//# sourceMappingURL=_page.server.ts.js.map
